import { Tabs } from 'antd';
import styled from 'styled-components';
import { Dropdown as AntDropdown, Flex, Input, Select } from 'UI';
import RangePicker from 'UI/DatePicker/RangePicker';

export const SInput = styled(Input)`
  min-height: 40px;
  border: 0 !important;
  border-radius: 20px !important;
  background: ${({ theme }) => theme.color.grey95} !important;
`;

export const SSelect = styled(Select)`
  min-height: 40px;

  &:not(.ant-select-focused) .ant-select-selector:not(:hover) {
    border-color: ${({ theme }) => theme.color.grey55} !important;
  }

  .ant-select-selector {
    min-height: 40px !important;
    display: flex !important;
    align-items: center !important;
  }
` as typeof Select;

export const STabs = styled(Tabs)`
  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-nav {
    margin: 0 !important;

    ::before {
      bottom: auto !important;
    }
  }

  .ant-tabs-nav-wrap {
    background-color: #eef2f5;
    border-radius: 8px;

    .ant-tabs-tab {
      border-radius: 8px !important;
      margin: 5px;

      &:hover:not(.ant-tabs-tab-active) {
        background-color: #3b4656;

        .ant-tabs-tab-btn {
          color: ${({ theme }) => theme.color.brand_black};
        }
      }
    }

    .ant-tabs-tab-active {
      background-color: #3b4656;

      .ant-tabs-tab-btn {
        color: ${({ theme }) => theme.color.white};
      }
    }
  }
`;

export const DropdownMenu = styled(Flex)`
  box-shadow: 0 2px 8px ${({ theme }) => theme.color.grey_15};
  overflow-y: auto;
  background: white;
  padding: 4px 0px;
  border-radius: 3px;
`;

export const SAntDropdown = styled(AntDropdown)<{ bordered: boolean; mainSearch?: boolean }>`
  min-height: 40px !important;
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => props.theme.color.grey55};
  background-color: ${(props) => props.theme.color.white};
  border-radius: 3px;
  transition: all 0.3s ease !important;

  cursor: pointer;
  color: ${(props) => props.theme.color.grey75};

  :hover {
    border-color: #ffcc33 !important;
  }

  :focus {
    border-color: #ffcc33 !important;
  }

  &.ant-dropdown-open {
    border-color: #ffcc33 !important;
    box-shadow: 0 0 3px #ffcc33 !important;
  }
`;

export const DropdownItem = styled(Flex)<{ isSelected: boolean }>`
  width: 100%;
  min-height: 32px !important;
  padding: 2px 12px;
  cursor: pointer;

  :hover {
    background-color: ${({ isSelected, theme }) => !isSelected && theme.color.grey_very_light_2};
  }

  background-color: ${({ isSelected }) => isSelected && '#fffef0 !important'};
`;

export const SRangePicker = styled(RangePicker)`
  transition: all 0.3s ease !important;
  :hover {
    border-color: #ffcc33 !important;
  }

  &.ant5-picker-focused {
    border-color: #ffcc33 !important;
    box-shadow: 0 0 3px #ffcc33 !important;
  }

  .ant5-picker-active-bar {
    background-color: #ffcc33 !important;
  }
`;
